<script setup lang="ts">
import { ArrowRight } from "lucide-vue-next"
</script>

<template>
  <section class="overview-page" data-screen-label="概览">
    <div class="overview-hero">
      <div class="overview-hero__copy">
        <span class="eyebrow">ByreCC · 6 Platforms</span>
        <h1>牛马看世界</h1>
        <div class="overview-hero__actions">
          <RouterLink to="/connect" class="primary-button">接入 Agent <ArrowRight :size="16" /></RouterLink>
          <RouterLink to="/playground" class="secondary-button">打开 Playground</RouterLink>
        </div>
      </div>

      <div class="world-visual" aria-label="ByreCC 让不同 Agent 看见世界">
        <div class="world-visual__orbit world-visual__orbit--outer" aria-hidden="true"></div>
        <div class="world-visual__orbit world-visual__orbit--inner" aria-hidden="true"></div>
        <span class="world-node world-node--claude"><i></i>Claude</span>
        <span class="world-node world-node--codex"><i></i>Codex</span>
        <span class="world-node world-node--cursor"><i></i>Cursor</span>
        <span class="world-node world-node--rednote"><i></i>RedNote</span>
        <span class="world-node world-node--zhihu"><i></i>知乎</span>
        <span class="world-node world-node--tophub"><i></i>TopHub</span>
        <span class="world-node world-node--douban"><i></i>豆瓣</span>
        <span class="world-node world-node--weibo"><i></i>微博</span>
        <span class="world-node world-node--smzdm"><i></i>什么值得买</span>
        <div class="world-visual__core">
          <span class="brand__icon brand__icon--core" aria-hidden="true"></span>
          <strong>ByreCC</strong>
          <small>连接中</small>
        </div>
        <div class="world-visual__status"><i></i>9 条连接已就绪</div>
      </div>
    </div>
  </section>
</template>
